import { type ParsedLocation } from '@tanstack/react-router'

export const checkIfLocationMatchesString = (
  location: ParsedLocation,
  pathString: string
) => locationToString(location) === pathString

export const locationToString = (location: ParsedLocation) =>
  `${location.pathname}${location.searchStr}`
